import * as libphonenumber from 'libphonenumber-js';
/**
 * Parses a phone number to an optional phone number object
 *
 * @param phoneNumber The phone number to parse
 * @returns The parsed phone number or null if the phone number is invalid
 */
export const parsePhoneNumberToOptional = (phoneNumber) => {
    if (!phoneNumber)
        return null;
    try {
        const parsedPhone = libphonenumber.parsePhoneNumber(phoneNumber, {
            extract: false,
            defaultCountry: 'US',
        });
        return parsedPhone?.number ?? null;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    }
    catch (e) {
        return null;
    }
};
/**
 * Parses a phone number from a string and formats it to a string when required
 *
 * @param phoneNumber The phone number to parse
 * @param countryCode The country code to use
 * @param format The format to use
 * @returns The parsed phone number or the original phone number if it is invalid
 */
export const parsedPhoneNumberFromString = (phoneNumber, countryCode = 'US', // Default country code as 'US'
format = 'INTERNATIONAL') => {
    // Parse the phone number using the provided country code as a fallback
    const parsedPhoneNumber = libphonenumber.parsePhoneNumberFromString(phoneNumber, countryCode);
    // If the parsed phone number is valid, return the formatted number in INTERNATIONAL format
    if (parsedPhoneNumber && parsedPhoneNumber.isValid()) {
        return parsedPhoneNumber.format(format); // Format with spaces, e.g., +1 719 553 9507
    }
    // If the number is invalid, return the input number as is
    return phoneNumber;
};
//# sourceMappingURL=parsePhoneNumber.js.map